import { useState, useEffect } from "react";
import { englishFontSettingsStore } from "../../stores/sessionStore";

const EnglishFontSettings=()=>{
    const [currentFont,setCurrentFont]=useState(null);
    const [currentFontSize,setCurrentFontSize]=useState(null);
    const [currentFontClasses,setCurrentFontClasses]=useState(null);

    const engFontArr=['Sans Serif','Open Sans','Droid Sans','Amiri','MeriWeather','Fira Mono'];

    const getFontClass=(fontId)=>{
        let fontName;
        switch(fontId){
            case '1':fontName='font-sans';break;
            case '2':fontName='font-OpenSansFont';break;
            case '3':fontName='font-DroidSans';break;
            case '4':fontName='font-Amiri';break;
            case '5':fontName='font-MerriweatherFont';break;
            case '6':fontName='font-FiraMonoFont';break;
            default:break;
        }
        return fontName;
    }

    const getFontSizeClass=(fSize)=>{
        let fontSize;
        switch(fSize){
            case '1':fontSize='fontSize-one';break;
            case '2':fontSize='fontSize-two';break;
            case '3':fontSize='fontSize-three';break;
            case '4':fontSize='fontSize-four';break;
            case '5':fontSize='fontSize-five';break;
            default:break;
        }
        return fontSize;
    }

    const updateFontClassesRecursively = (parentElement, fontName) => {
        parentElement.childNodes.forEach((child) => {
            if (child.nodeType === 1) { // Check if the child is an element node (nodeType === 1)
                // Remove classes starting with 'font-'
                removeClassByPrefix(child, 'font-');
                // Add the new font class
                child.classList.add(fontName);
                // Recursively call the function for any sub-child elements (descendants)
                updateFontClassesRecursively(child, fontName);
            }
        });
    };

    const updateFontSizeClassesRecursive = (parentElement, fontSize) => {
        // Loop over each child of the parent element
        parentElement.childNodes.forEach((child) => {
          // Check if the child is an element node (ignoring text nodes or comments)
          if (child.nodeType === 1) { // Node type 1 is an element node
            // Remove specific font size classes
            child.classList.remove('text-4xl', 'text-lg');
            // Remove any classes starting with 'fontSize-'
            removeClassByPrefix(child, 'fontSize-');
            // Add the new font size class
            child.classList.add(fontSize);
            // Recursively call the function for any child elements (sub-sub children, etc.)
            updateFontSizeClassesRecursive(child, fontSize);
          }
        });
    };

    const handleFont=(fontId)=>{
        let fontSettingsData=JSON.parse(localStorage.getItem('fontSettings'));
        const fontName=getFontClass(fontId);
        // Select all elements with the 'eng-text-setting' class
        const elements = document.querySelectorAll('.eng-text-setting');
        elements.forEach((element) => {
            removeClassByPrefix(element, 'font-'); // Remove classes with 'font-' prefix
            element.classList.add(fontName); // Add the new font class
        });
        document.querySelectorAll('.history-eng-contents').forEach((item) => {
            updateFontClassesRecursively(item, fontName);
        });
        fontSettingsData.englishFont=fontId;
        localStorage.setItem('fontSettings',JSON.stringify(fontSettingsData));
        refreshTafsirFrame();
        setCurrentFont(fontId);
    }

    const handleFontSize=(event)=>{
        const fSize=event.target.value;
        let fontSettingsData=JSON.parse(localStorage.getItem('fontSettings'));
        const fontSize=getFontSizeClass(fSize);
        document.querySelectorAll('.eng-text-setting').forEach((item) => {
            // Remove specific font size classes
            item.classList.remove('text-4xl', 'text-lg');
            // Remove any classes starting with 'fontSize-'
            removeClassByPrefix(item, 'fontSize-');
            // Add the new font size class
            item.classList.add(fontSize);
        });

        // Query all elements with the class '.history-eng-contents'
        document.querySelectorAll('.history-eng-contents').forEach((item) => {
            updateFontSizeClassesRecursive(item, fontSize);
        });
        fontSettingsData.englishFontSize=fSize;
        localStorage.setItem('fontSettings',JSON.stringify(fontSettingsData));
        refreshTafsirFrame();
        setCurrentFontSize(fSize);
    }

    useEffect(()=>{
        if(currentFont!==null&&currentFontSize!==null)
        {
            const fontClass = getFontClass(currentFont);
            const fontSizeClass = getFontSizeClass(currentFontSize);
            setCurrentFontClasses({ fontClass, fontSizeClass });
            englishFontSettingsStore.set({ fontClass, fontSizeClass });
        }
    },[currentFont,currentFontSize]);

    useEffect(()=>{
        const fontSettings=JSON.parse(localStorage.getItem("fontSettings"));
        if(fontSettings!==null)
        {
            setCurrentFont(fontSettings.englishFont);
            setCurrentFontSize(fontSettings.englishFontSize);
        }
    },[]);

    return (
        <div className="">
            <p className={`text-white mt-[25px] mb-[15px] text-style-preview ${currentFontClasses?`${currentFontClasses.fontClass} ${currentFontClasses.fontSizeClass}`:``}`}>Holy Qur'an</p>
            <h4 className="text-white my-6">English font</h4>
            {
                engFontArr.map((font,fontIndex)=>{
                    const fontId=fontIndex+1;
                    return (
                        <div key={fontId} className="flex items-center ml-2 mb-4">
                            <input id={"englishFont-react-"+fontId} type="radio" value="" name="englishFontRadioReact" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300" onChange={()=>{
                                handleFont(fontId.toString());
                            }} checked={fontId.toString()===currentFont} />
                            <label htmlFor={"englishFont-react-"+fontId} className="ml-2 text-sm font-medium text-white">{font}</label>
                        </div>
                    );
                })
            }

            <h4 className="text-white mt-10 mb-6">English font size</h4>
            <label htmlFor="english-font-size" className="block mb-2 text-sm font-medium text-white">Font size</label>
            <input id="english-font-size" type="range" min="1" max="4" value={currentFontSize?currentFontSize:"5"} step="1" className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700 mb-[120px]" onChange={handleFontSize}/>
        </div>
    );
}

export default EnglishFontSettings;